<div class="row">
    <div class="col-lg col-md col-xs col-xl col-sm w-100">
        <mat-card class="mat-elevation-z8 w-100">
            <form [formGroup]="formulario" (keydown.enter)="$event.preventDefault()">
                <div class="row">
                    <div class="col-lg col-md col-xs col-xl col-sm">
                        <p class="tituloLeft">{{step}}</p>
                    </div>
                    <div class="col-lg-2 col-md-2 col-xs-2 col-xl-2 col-sm-2 text-right">
                        <i class="fa fa-window-minimize iconMenu" matTooltip="Minimizar" (click)="changeCollapse()"
                            *ngIf="!collapseCard"></i>
                        <i class="fa fa-window-maximize iconMenu" matTooltip="Maximizar" (click)="changeCollapse()"
                            *ngIf="collapseCard"></i>
                    </div>
                </div>

                <mat-card-content *ngIf="!collapseCard">
                    <!-- Linha 1 -->
                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Hibrido
                                </mat-label>
                                <input matInput id="txtRnc" #txtRnc maxlength="20"
                                    formControlName="hibrido" >
                                <i matSuffix class="{{iconEnableeField}}"></i>
                                <mat-hint align="end">{{txtRnc.value.length}} / 20</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.hibrido)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Safra
                                </mat-label>
                                <input matInput id="txtRnc" #txtRnc maxlength="20"
                                    formControlName="safra" >
                                <i matSuffix class="{{iconEnableeField}}"></i>
                                <mat-hint align="end">{{txtRnc.value.length}} / 20</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.safra)}}</mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    
                    <!-- Linha 2 -->
                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Padrão Percentil
                                </mat-label>
                                <input matInput id="txtPdr" #txtPdr maxlength="20"
                                    formControlName="padrao_percentil" >
                                <i matSuffix class="{{iconEnableeField}}"></i>
                                <mat-hint align="end">{{txtPdr.value.length}} / 20</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.padrao_percentil)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Umidade Máxima
                                </mat-label>
                                <input matInput id="txtUmid" #txtUmid maxlength="20"
                                    formControlName="umidade_maxima" >
                                <i matSuffix class="{{iconEnableeField}}"></i>
                                <mat-hint align="end">{{txtUmid.value.length}} / 20</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.umidade_maxima)}}</mat-error>
                            </mat-form-field>
                        </div>
        
                    </div>          
              

                </mat-card-content>
            </form>
        </mat-card>
    </div>
</div>